import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './public.css';

export default function InfoPage({ title, intro, children }: { title: string; intro: string; children: ReactNode }) {
  return (
    <article className="public-info" aria-labelledby="public-info-title">
      <Link to="/" className="public-back">Back to Home</Link>
      <header>
        <h1 id="public-info-title">{title}</h1>
        <p>{intro}</p>
      </header>
      {children}
      <footer aria-label="LAVYN information">
        <Link to="/about">About LAVYN</Link>
        <Link to="/contact">Help &amp; Support</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
      </footer>
    </article>
  );
}
